import { z } from 'zod';

export const PerformanceReviewReportFilter = z.object({
  /** A period key such as `2027-Q1_Q2`. Empty means the newest period that has rows. */
  period: z.string().catch(''),
  /** Empty means all countries. */
  countryIds: z.array(z.string()).catch([]),
});

export type PerformanceReviewReportFilterType = z.infer<typeof PerformanceReviewReportFilter>;
